import { render, staticRenderFns } from "./nav-avatar.vue?vue&type=template&id=17aea691&scoped=true&"
import script from "./nav-avatar.vue?vue&type=script&lang=js&"
export * from "./nav-avatar.vue?vue&type=script&lang=js&"
import style0 from "./nav-avatar.vue?vue&type=style&index=0&id=17aea691&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aea691",
  null
  
)

export default component.exports